import { ComponentKey } from "enums/componentKey";
import { InputsConfig } from "types/form/inputsConfig";
import { PlateformeFormFieldNames } from "./PlateformeFormFieldNames";
import { ThemeFormValues } from "./ThemeFormValues";

/**
 * Polices proposées : Lato = police de l'app (seule chargée via Google Fonts),
 * les autres sont des polices système sûres — une police non chargée ne
 * rendrait pas. `css` = valeur font-family valide (noms multi-mots quotés).
 */
const FONT_FAMILY_CHOICES: { value: string; css: string }[] = [
  { value: 'Lato', css: 'Lato' },
  { value: 'Arial', css: 'Arial' },
  { value: 'Helvetica', css: 'Helvetica' },
  { value: 'Verdana', css: 'Verdana' },
  { value: 'Tahoma', css: 'Tahoma' },
  { value: 'Trebuchet MS', css: '"Trebuchet MS"' },
  { value: 'Georgia', css: 'Georgia' },
  { value: 'Times New Roman', css: '"Times New Roman"' },
  { value: 'Courier New', css: '"Courier New"' },
];

export const themeInputsConfig: InputsConfig<keyof ThemeFormValues> = {
  [PlateformeFormFieldNames.PrimaryColor]: {
    componentKey: ComponentKey.ColorPicker,
    name: PlateformeFormFieldNames.PrimaryColor,
    required: true,
    label: 'ACTOR_FORM.ORGANIZATION.LABELS.PRIMARY_COLOR',
  },
  [PlateformeFormFieldNames.SecondaryColor]: {
    componentKey: ComponentKey.ColorPicker,
    name: PlateformeFormFieldNames.SecondaryColor,
    required: true,
    label: 'ACTOR_FORM.ORGANIZATION.LABELS.SECONDARY_COLOR',
  },
  [PlateformeFormFieldNames.BackgroundColor]: {
    componentKey: ComponentKey.ColorPicker,
    name: PlateformeFormFieldNames.BackgroundColor,
    required: true,
    label: 'ACTOR_FORM.ORGANIZATION.LABELS.BACKGROUND_COLOR',
  },
  [PlateformeFormFieldNames.SurfaceColor]: {
    componentKey: ComponentKey.ColorPicker,
    name: PlateformeFormFieldNames.SurfaceColor,
    required: true,
    label: 'ACTOR_FORM.ORGANIZATION.LABELS.SURFACE_COLOR',
  },
  [PlateformeFormFieldNames.AccentColor]: {
    componentKey: ComponentKey.ColorPicker,
    name: PlateformeFormFieldNames.AccentColor,
    required: true,
    label: 'ACTOR_FORM.ORGANIZATION.LABELS.ACCENT_COLOR',
  },
  [PlateformeFormFieldNames.ErrorColor]: {
    componentKey: ComponentKey.ColorPicker,
    name: PlateformeFormFieldNames.ErrorColor,
    required: true,
    label: 'ACTOR_FORM.ORGANIZATION.LABELS.ERROR_COLOR',
  },
  [PlateformeFormFieldNames.SuccessColor]: {
    componentKey: ComponentKey.ColorPicker,
    name: PlateformeFormFieldNames.SuccessColor,
    required: true,
    label: 'ACTOR_FORM.ORGANIZATION.LABELS.SUCCESS_COLOR',
  },
  [PlateformeFormFieldNames.WarningColor]: {
    componentKey: ComponentKey.ColorPicker,
    name: PlateformeFormFieldNames.WarningColor,
    required: true,
    label: 'ACTOR_FORM.ORGANIZATION.LABELS.WARNING_COLOR',
  },
  [PlateformeFormFieldNames.InfoColor]: {
    componentKey: ComponentKey.ColorPicker,
    name: PlateformeFormFieldNames.InfoColor,
    required: true,
    label: 'ACTOR_FORM.ORGANIZATION.LABELS.INFO_COLOR',
  },
  [PlateformeFormFieldNames.FontFamily]: {
    componentKey: ComponentKey.Dropdown,
    name: PlateformeFormFieldNames.FontFamily,
    required: true,
    label: 'ACTOR_FORM.ORGANIZATION.LABELS.FONT_FAMILY',
    placeholder: 'ACTOR_FORM.ORGANIZATION.PLACEHOLDERS.FONT_FAMILY',
    // Convention des sélecteurs de police (Google Docs, Adobe) : nom rendu dans
    // sa propre fonte + spécimen « AaBbCc 0123 » discret à droite de l'option.
    items: FONT_FAMILY_CHOICES.map((font) => ({
      key: font.value,
      label: font.value,
      labelStyle: { fontFamily: font.css },
      trailingLabel: 'AaBbCc 0123',
      trailingStyle: { fontFamily: font.css },
    })),
  },
};
